<template>
  <list-layout class="list-layout" :pageSize="pageSize" :currentPage="currentPage" :total="total"  @current-change="handleCurrentChange" @size-change="handleSizeChange">
    <span slot="title">委托租赁收入列表</span>
    <el-form slot="search-bar" :inline="true">
      <el-form-item label="物料名称">
        <el-input class="form-input" v-model="Search.Product" placeholder="请输入物料名称/物料编码"></el-input>
      </el-form-item>
      <el-form-item label="品牌">
        <el-select v-model="Search.BrandName" filterable  placeholder="请选择或输入品牌" clearable>
          <el-option
            v-for="item in BrandNames"
            :key="item.Name"
            :label="item.Name"
            :value="item.Name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机型">
        <el-select v-model="Search.ProductModel" filterable placeholder="请选择或输入机型" clearable>
          <el-option
            v-for="item in ProductModels"
            :key="item.Name"
            :label="item.Name"
            :value="item.Name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模块">
        <el-select v-model="Search.ProductModule" filterable placeholder="请选择或输入模块" clearable>
          <el-option
            v-for="item in ProductModules"
            :key="item.Name"
            :label="item.Name"
            :value="item.Name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="批次号">
        <el-input class="form-input" v-model="Search.BatchCode" placeholder="批次号"></el-input>
      </el-form-item>
      <el-form-item label="区域">
        <el-select v-model="Search.Region" filterable placeholder="请选择或输入区域" clearable>
          <el-option
            v-for="item in Regions"
            :key="item.Name"
            :label="item.Name"
            :value="item.Name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="IsLoading" @click="handleSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="tab" slot="tabs">
      <el-tabs class="tab" :value="activename" @tab-click="handleTabClick">
        <el-tab-pane label="租赁中" name="租赁中"></el-tab-pane>
        <el-tab-pane label="待收款" name="待收款"></el-tab-pane>
        <el-tab-pane label="已收款" name="已收款"></el-tab-pane>
      </el-tabs>
      <div class="payment_box" >
        <span v-if="this.activename==='待收款'">待收款：{{getWaitTotal() | amount}}</span>
        <span v-if="this.activename==='已收款'">已收款：{{getWaitTotal() | amount}}</span>        
      </div>
    </div>
    <table v-loading="IsLoading" element-loading-text="加载中" class="sell_table" slot="main-content">
      <thead>
        <tr>
          <td width="230">物料名称／编码</td>
          <td width="230">客户物料名称／编码</td>
          <td>品项</td>
          <td>品牌</td>
          <td>机型</td>
          <td>模块</td>
          <td>数量</td>
          <td width="130">开始时间</td>
          <td width="130">结束时间</td>
          <!-- <td>操作</td> -->
        </tr>
      </thead>
      <tbody v-for="item in tableData">
        <div class="space_box"></div>
        <tr>
          <td colspan="10" class="first_td">
            <span>流水号：{{item.Code}}</span>
            <span>批次号：{{item.BatchCode}}</span>
            <span>租赁价格：¥{{item.UnitPrice}}</span>
            <span>分成比例：{{Scale(item)}}</span>
            <span>累计收益：¥{{item.Receipted}}</span>
            <span>区域：{{item.Area}}</span>
          </td>
        </tr>
        <tr>
          <td>
            {{item.ItemName}}<br>
            <p v-if='item.ItemCode.length>20'>物料编码：{{item.ItemCode.substring(0,20)}}</p>
            <p v-else>物料编码：{{item.ItemCode}}</p>
          </td>
          <td>
            {{item.CustomerItemName}}<br>
            <p v-if='item.ItemCode.length>20'>客户物料编码：{{item.CustomerItemCode.substring(0,20)}}</p>
            <p v-else>客户物料编码：{{item.CustomerItemCode}}</p>
          </td>
          <td><el-tag :type="item.ItemQualityName | ConditionColor">{{item.ItemQualityName}}</el-tag></td>
          <td>{{item.Brand}}</td>
          <td>{{item.Machine}}</td>
          <td>{{item.Module}}</td>
          <td>{{item.Quantity}}</td>
          <td>{{item.StartTime | date('YYYY-MM-DD')}}</td>
          <td>{{item.EndTime | date('YYYY-MM-DD') | NullDate}}</td>
         <!--  <td>
            <el-button  type="text" @click.native="toDetail(item)" size="small">查看相关详情</el-button>
          </td> -->
        </tr>
      </tbody>  
    </table>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/pages/Repair/ListLayout'
import o from '@/odata'
export default {
  data() {
    return {
      Search: {
        Product: null,
        BrandName: null,
        ProductModel: null,
        ProductModule: null,
        Region: null,
        BatchCode: null,
      },
      activename: '租赁中',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      RepairTypes: [
        {label: '租赁维修', value: 'rental'},
        {label: '委托维修', value: 'delegated'},
        {label: '代管维修', value: 'managed'},
        {label: '拆件维修', value: 'parts'},
      ],
      BrandNames: [],
      ProductModules: [],
      ProductModels: [],
      tableData: [],
      Regions: [],
      sellListURL: process.env.API_HOST + '/finance/RentalOrder/Distribution/Report',
      IsLoading: false,
    }
  },
  methods: {
    Scale: function(item) {
      return item.Scale / 10 + ':' + (10 - (item.Scale / 10))
    },
    toDetail: function(props) {
      this.$router.push('/repair/' + props.row.Id)
    },
    handleSearch() {
      this.IsLoading = true
      let filters = ''
      if (this.Search.BrandName) {
        filters += '&brand=' + this.Search.BrandName
      }
      if (this.Search.Region) {
        filters += '&area=' + this.Search.Region
      }
      if (this.Search.Product) {
        filters += '&material=' + this.Search.Product
      }
      if (this.Search.BatchCode) {
        filters += '&batchCode=' + this.Search.BatchCode
      }
      if (this.Search.ProductModel) {
        filters += '&machine=' + this.Search.ProductModel
      }
      if (this.Search.ProductModule) {
        filters += '&module=' + this.Search.ProductModule
      }
      // filters.join('&')
      let URL = this.sellListURL + '?State=' + this.activename + filters + '&pageIndex=' + this.currentPage + '&pageSize=' + this.pageSize
      this.$http.get(URL).then((response) => {
        this.IsLoading = false
        this.tableData = response.data.List
        this.total = response.data.Total
      }).catch((response) => {
        this.IsLoading = false
      })
    },
    handleTabClick({name}) {
      this.activename = name
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.handleSearch()
    },
    initBrandNames: function() {
      const BrandName = o('ProductBrand')
      BrandName.get().then((data) => {
        this.BrandNames = data.data
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    initProductModel: function() {
      const ProductModel = o('ProductModel')
      ProductModel.get().then((data) => {
        this.ProductModels = data.data
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    initProductModule: function() {
      const ProductModule = o('ProductModule')
      ProductModule.get().then((data) => {
        this.ProductModules = data.data
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    initReion: function() {
      const Region = o('Region')
      Region.get().then(({ data, inlinecount }) => {
        this.Regions = data
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    getWaitTotal() {
      var total = 0
      this.tableData.forEach(function(row) {
        total += row.UnitPrice
      }, this)
      return total
    },
  },
  components: {
    ListLayout,
    // ComplexGrid,
  },
  created() {
    this.handleSearch()
    this.initBrandNames()
    this.initProductModel()
    this.initProductModule()
    this.initReion()
  },
}
</script>

<style lang="less" scoped>
.sell_table{
  width: 100%;
  margin-bottom: 10px;
  border-collapse: collapse;
  thead{
    margin-bottom: 20px;
    td{
      background-color: #e5e9f2;
      font-size: 14px;
      font-weight: bold;
      color: #43484d;
      line-height: 42px;
      height: 42px;
      padding-left: 18px;
    }
  }
  tbody{
    border-spacing: 10px;
    .space_box{
      width: 100%;
      height: 10px;
    }
    td{
      padding: 10px 18px;
      font-size: 14px;
      color: #1f2d3d;
      border-bottom: 1px solid #dfe6ec;
    }
    td.first_td{
      padding-top: 0;
      padding-bottom: 0;
      border-bottom: none;
      background-color: #e5e9f2;
      color: #43484d;
      font-size: 12px;
      line-height: 47px;
      height: 47px;
      span{
        margin-right: 20px;
      }
    }
  }
}
.form-input {
  width: 260px;
}
.list-layout .complex-table .sub-row-table .sub-body .text-center{
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}
.main-content{
  .tab{
    .el-tabs__active-bar{
      background-color: rgba(0,0,0,0);
    }
  }
}
.payment_box{
  position: absolute;
  top:15px;
  right: 15px;
}
</style>



// WEBPACK FOOTER //
// EntrustLeasePage.vue?5cfff4d6